export const session:any ={
    erpUser:undefined
} 